import { render, staticRenderFns } from "./CheckinTermsPT.vue?vue&type=template&id=47bb4ce6&"
import script from "./CheckinTermsPT.vue?vue&type=script&lang=js&"
export * from "./CheckinTermsPT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports